import * as Yup from "yup";
import PhDUploadFormModel from "./PhDUploadFormModel";

// const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
const {
  formField: {
    // info
    statementReportGuideline,
    //info

    /////////////////Page1Form 3Year///////////////////////////
    yourProgramType,
    sendingScholarshipReport,
    semester,
    /////////////////Page1Form 3Year///////////////////////////

    /////////////////Page2Form 2A/////////////////////////////
    receivingScholarship,
    reportNo,
    previousSemester,
    inputList,
    receivedGradeReportGpa,
    thesisCreditsProgram,
    currentTotalThesisCredits,
    remainingThesisCreditsProgram,
    gpa,
    gpax,
    currentTotalCredits,
    remainingCreditsProgram,
    researchTitleSelect,
    mainResearchArea,
    researchTitle,
    /////////////////Page2Form 2A/////////////////////////////

    /////////////////Page3Form 2B/////////////////////////////
    startWritingResearchProposal,
    uploadCurrentResearchProposal,
    qualifyingExamResult,
    whenQualifyingExamination,
    proposalExaminationResult,
    whenProposalExamination,
    presentProgressResearchProject,
    subjectAreaPublished,
    manuscriptPublication,
    manuscriptId,
    journalRanking,
    conductingResearchAbroad6Months,
    answerPlaning,
    answerCountryPlan,
    highPerformanceProfessor,
    professorCollaboratorName,
    instituteProfessorCollaborator,
    /////////////////Page3Form 2B/////////////////////////////

    /////////////////Page2Form 2C/////////////////////////////
    yourResearchField,
    presentProgressResearchProject2c,
    articleTitle,
    manuscriptId2c,
    typeManuscript,
    journal,
    subjectAreaCategory,
    journalRanking2c,
    authors,
    uploadResearchPublication,
    receivedDate,
    revisedDate,
    acceptedDate,
    publishedDate,
    /////////////////Page2Form 2C/////////////////////////////
  },
} = PhDUploadFormModel;

export default function getSchemaForm(page, activeStep, role) {
  const FORM_2A = "2a";
  const FORM_2AB = "2ab";
  const FORM_2C = "2c";
  const ROLE_PHD_5Y = "phd_5y";

  const schemaDefault = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      ),
    }),

    Yup.object().shape({
      [yourProgramType.name]: Yup.string().required(
        `${yourProgramType.requiredErrorMsg}`
      ),
      [sendingScholarshipReport.name]: Yup.string().required(
        `${sendingScholarshipReport.requiredErrorMsg}`
      ),
      [semester.name]:
        page === FORM_2AB || (page === FORM_2A && role === ROLE_PHD_5Y)
          ? Yup.string().required(`${semester.requiredErrorMsg}`)
          : Yup.string(),
    }),
  ];

  const schema2A = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      ),
    }),

    Yup.object().shape({
      [yourProgramType.name]: Yup.string().required(
        `${yourProgramType.requiredErrorMsg}`
      ),
      [sendingScholarshipReport.name]: Yup.string().required(
        `${sendingScholarshipReport.requiredErrorMsg}`
      ),
      [semester.name]:
        page === FORM_2AB || (page === FORM_2A && role === ROLE_PHD_5Y)
          ? Yup.string().required(`${semester.requiredErrorMsg}`)
          : Yup.string(),
    }),



    Yup.object().shape({
      // [receivingScholarship.name]: Yup.string().required(
      //   `${receivingScholarship.requiredErrorMsg}`
      // ),
      // [reportNo.name]: Yup.string().required(`${reportNo.requiredErrorMsg}`),
      // [previousSemester.name]: Yup.string().required(
      //   `${previousSemester.requiredErrorMsg}`
      // ),
      // [inputList.name]: Yup.array().of(
      //   Yup.object().shape({
      //     [inputList.subMenu[0].subjectCourseNo.name]: Yup.string()
      //       .trim()
      //       .required(
      //         `${inputList.subMenu[0].subjectCourseNo.requiredErrorMsg}`
      //       ),
      //     [inputList.subMenu[0].courseTitle.name]: Yup.string()
      //       .trim()
      //       .required(`${inputList.subMenu[0].courseTitle.requiredErrorMsg}`),
      //     [inputList.subMenu[0].credit.name]: Yup.string()
      //       .trim()
      //       .required(`${inputList.subMenu[0].credit.requiredErrorMsg}`),
      //     [inputList.subMenu[0].grade.name]: Yup.string()
      //       .trim()
      //       .required(`${inputList.subMenu[0].grade.requiredErrorMsg}`),
      //   })
      // ),
      // [thesisCreditsProgram.name]: Yup.string()
      //   .trim()
      //   .required(`${thesisCreditsProgram.requiredErrorMsg}`),
      // [receivedGradeReportGpa.name]: Yup.string().trim(),
      // // .required(`${receivedGradeReportGpa.requiredErrorMsg}`)
      // [currentTotalThesisCredits.name]: Yup.string()
      //   .trim()
      //   .required(`${currentTotalThesisCredits.requiredErrorMsg}`),
      // [remainingThesisCreditsProgram.name]: Yup.string()
      //   .trim()
      //   .required(`${remainingThesisCreditsProgram.requiredErrorMsg}`),
      // [gpa.name]: Yup.string().trim().required(`${gpa.requiredErrorMsg}`),
      // [gpax.name]: Yup.string().trim().required(`${gpax.requiredErrorMsg}`),
      // [currentTotalCredits.name]: Yup.string()
      //   .trim()
      //   .required(`${currentTotalCredits.requiredErrorMsg}`),
      // [remainingCreditsProgram.name]: Yup.string()
      //   .trim()
      //   .required(`${remainingCreditsProgram.requiredErrorMsg}`),
      // [researchTitleSelect.name]: Yup.string()
      //   .trim()
      //   .required(`${researchTitleSelect.requiredErrorMsg}`),
      // [mainResearchArea.name]: Yup.string()
      //   .trim()
      //   .required(`${mainResearchArea.requiredErrorMsg}`),
      // [researchTitle.name]: Yup.string()
      //   .trim()
      //   .required(`${researchTitle.requiredErrorMsg}`),
      [receivingScholarship.name]: Yup.string(),
      [reportNo.name]: Yup.string(),
      [previousSemester.name]: Yup.string(),
      [inputList.name]: Yup.array().of(
        Yup.object().shape({
          [inputList.subMenu[0].subjectCourseNo.name]: Yup.string().trim(),
          [inputList.subMenu[0].courseTitle.name]: Yup.string().trim(),
          [inputList.subMenu[0].credit.name]: Yup.string().trim(),
          [inputList.subMenu[0].grade.name]: Yup.string().trim(),
        })
      ),
      [thesisCreditsProgram.name]: Yup.string().trim(),
      [receivedGradeReportGpa.name]: Yup.string().trim(),
      // .required(`${receivedGradeReportGpa.requiredErrorMsg}`)
      [currentTotalThesisCredits.name]: Yup.string().trim(),
      [remainingThesisCreditsProgram.name]: Yup.string().trim(),
      [gpa.name]: Yup.string().trim(),
      [gpax.name]: Yup.string().trim(),
      [currentTotalCredits.name]: Yup.string().trim(),
      [remainingCreditsProgram.name]: Yup.string().trim(),
      [researchTitleSelect.name]: Yup.string().trim(),
      [mainResearchArea.name]: Yup.string().trim(),
      [researchTitle.name]: Yup.string().trim(),
    }),
  ];



  const schema2AB = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      ),
    }),

    Yup.object().shape({
      [yourProgramType.name]: Yup.string().required(
        `${yourProgramType.requiredErrorMsg}`
      ),
      [sendingScholarshipReport.name]: Yup.string().required(
        `${sendingScholarshipReport.requiredErrorMsg}`
      ),
      [semester.name]:
        page === FORM_2AB || (page === FORM_2A && role === ROLE_PHD_5Y)
          ? Yup.string().required(`${semester.requiredErrorMsg}`)
          : Yup.string(),
    }),

    Yup.object().shape({
      [receivingScholarship.name]: Yup.string().required(
        `${receivingScholarship.requiredErrorMsg}`
      ),
      [reportNo.name]: Yup.string().required(`${reportNo.requiredErrorMsg}`),
      [previousSemester.name]: Yup.string().required(
        `${previousSemester.requiredErrorMsg}`
      ),
      [inputList.name]: Yup.array().of(
        Yup.object().shape({
          [inputList.subMenu[0].subjectCourseNo.name]: Yup.string()
            .trim()
            .required(
              `${inputList.subMenu[0].subjectCourseNo.requiredErrorMsg}`
            ),
          [inputList.subMenu[0].courseTitle.name]: Yup.string()
            .trim()
            .required(`${inputList.subMenu[0].courseTitle.requiredErrorMsg}`),
          [inputList.subMenu[0].credit.name]: Yup.string()
            .trim()
            .required(`${inputList.subMenu[0].credit.requiredErrorMsg}`),
          [inputList.subMenu[0].grade.name]: Yup.string()
            .trim()
            .required(`${inputList.subMenu[0].grade.requiredErrorMsg}`),
        })
      ),
      [thesisCreditsProgram.name]: Yup.string()
        .trim()
        .required(`${thesisCreditsProgram.requiredErrorMsg}`),
      [receivedGradeReportGpa.name]: Yup.string().trim(),
      // .required(`${receivedGradeReportGpa.requiredErrorMsg}`),
      [currentTotalThesisCredits.name]: Yup.string()
        .trim()
        .required(`${currentTotalThesisCredits.requiredErrorMsg}`),
      [remainingThesisCreditsProgram.name]: Yup.string()
        .trim()
        .required(`${remainingThesisCreditsProgram.requiredErrorMsg}`),
      [gpa.name]: Yup.string().trim().required(`${gpa.requiredErrorMsg}`),
      [gpax.name]: Yup.string().trim().required(`${gpax.requiredErrorMsg}`),
      [currentTotalCredits.name]: Yup.string()
        .trim()
        .required(`${currentTotalCredits.requiredErrorMsg}`),
      [remainingCreditsProgram.name]: Yup.string()
        .trim()
        .required(`${remainingCreditsProgram.requiredErrorMsg}`),
      [researchTitleSelect.name]: Yup.string().required(
        `${researchTitleSelect.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitle.name]: Yup.string()
        .trim()
        .required(`${researchTitle.requiredErrorMsg}`),
    }),

    Yup.object().shape({
      [startWritingResearchProposal.name]: Yup.string().required(
        `${startWritingResearchProposal.requiredErrorMsg}`
      ),
      [uploadCurrentResearchProposal.name]: Yup.object()
        .shape({
          [uploadCurrentResearchProposal.file]: Yup.object(),
        })
        .nullable(),
      // .required(`${uploadCurrentResearchProposal.requiredErrorMsg}`),
      [qualifyingExamResult.name]: Yup.string().required(
        `${qualifyingExamResult.requiredErrorMsg}`
      ),
      [whenQualifyingExamination.name]: Yup.string().nullable(),
      // .required(`${whenQualifyingExamination.requiredErrorMsg}`),
      [proposalExaminationResult.name]: Yup.string().required(
        `${proposalExaminationResult.requiredErrorMsg}`
      ),
      [whenProposalExamination.name]: Yup.string().nullable(),
      // .required(`${whenProposalExamination.requiredErrorMsg}`),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      ),
      [subjectAreaPublished.name]: Yup.string()
        .trim()
        .required(`${subjectAreaPublished.requiredErrorMsg}`),
      [manuscriptPublication.name]: Yup.object()
        .shape({
          [manuscriptPublication.file]: Yup.object(),
        })
        .nullable(),
      // .required(`${manuscriptPublication.requiredErrorMsg}`),
      [manuscriptId.name]: Yup.string().trim(),
      // .required(`${manuscriptId.requiredErrorMsg}`),
      [journalRanking.name]: Yup.string().required(
        `${journalRanking.requiredErrorMsg}`
      ),
      [conductingResearchAbroad6Months.name]: Yup.string().required(
        `${conductingResearchAbroad6Months.requiredErrorMsg}`
      ),
      [answerPlaning.name]: Yup.string().trim(),
      // .required(`${answerPlaning.requiredErrorMsg}`),
      [answerCountryPlan.name]: Yup.string().trim(),
      // .required(`${answerCountryPlan.requiredErrorMsg}`),
      [highPerformanceProfessor.name]: Yup.string().required(
        `${highPerformanceProfessor.requiredErrorMsg}`
      ),
      [professorCollaboratorName.name]: Yup.string().trim(),
      // .required(`${professorCollaboratorName.requiredErrorMsg}`),
      [instituteProfessorCollaborator.name]: Yup.string().trim(),
      // .required(`${instituteProfessorCollaborator.requiredErrorMsg}`),
    }),
  ];

  const schema2C = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      ),
    }),

    Yup.object().shape({
      [yourProgramType.name]: Yup.string().required(
        `${yourProgramType.requiredErrorMsg}`
      ),
      [sendingScholarshipReport.name]: Yup.string().required(
        `${sendingScholarshipReport.requiredErrorMsg}`
      ),
      [semester.name]:
        page === FORM_2AB || (page === FORM_2A && role === ROLE_PHD_5Y)
          ? Yup.string().required(`${semester.requiredErrorMsg}`)
          : Yup.string(),
    }),

    Yup.object().shape({
      [yourResearchField.name]: Yup.string().required(
        `${yourResearchField.requiredErrorMsg}`
      ),
      [presentProgressResearchProject2c.name]: Yup.string().required(
        `${presentProgressResearchProject2c.requiredErrorMsg}`
      ),
      [articleTitle.name]: Yup.string()
        .trim()
        .required(`${articleTitle.requiredErrorMsg}`),
      [manuscriptId2c.name]: Yup.string().trim(),
      // .required(`${manuscriptId2c.requiredErrorMsg}`),
      [typeManuscript.name]: Yup.string().trim(),
      // .required(`${typeManuscript.requiredErrorMsg}`),
      [journal.name]: Yup.string()
        .trim()
        .required(`${journal.requiredErrorMsg}`),
      [subjectAreaCategory.name]: Yup.string()
        .trim()
        .required(`${subjectAreaCategory.requiredErrorMsg}`),
      [journalRanking2c.name]: Yup.string()
        .trim()
        .required(`${journalRanking2c.requiredErrorMsg}`),
      [authors.name]: Yup.string().trim(),
      // .required(`${authors.requiredErrorMsg}`),
      [uploadResearchPublication.name]: Yup.object()
        .shape({
          [uploadResearchPublication.file]: Yup.object(),
        })
        .nullable()
        .required(`${uploadResearchPublication.requiredErrorMsg}`),
      [receivedDate.name]: Yup.string()
        .nullable()
        .required(`${receivedDate.requiredErrorMsg}`),
      [revisedDate.name]: Yup.string()
        .nullable()
        .required(`${revisedDate.requiredErrorMsg}`),
      [acceptedDate.name]: Yup.string()
        .nullable()
        .required(`${acceptedDate.requiredErrorMsg}`),
      [publishedDate.name]: Yup.string()
        .nullable()
        .required(`${publishedDate.requiredErrorMsg}`),
    }),
  ];

  switch (page) {
    case FORM_2A:
      return schema2A[activeStep];
    case FORM_2AB:
      return schema2AB[activeStep];
    case FORM_2C:
      return schema2C[activeStep];
    default:
      return schemaDefault[activeStep];
  }
}
